var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-number-counter"},[_c('div',{staticClass:"left",on:{"click":_vm.leftClick}}),_c('div',{staticClass:"center"},[_vm._v(_vm._s(_vm.value))]),_c('div',{staticClass:"right",on:{"click":_vm.rightClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }